
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as LikeIcon } from "../fontello/icons/svg/ic_like.svg"


const Like = ({ ...props }) => (
  <SvgIcon
    component={LikeIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Like
